// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getMonthWiseInterestSummaryReportExcelFailure,
	getMonthWiseInterestSummaryReportExcelResponseChanged,
	getMonthWiseInterestSummaryReportExcelSuccess,
	getMonthWiseInterestSummaryReportFailure,
	getMonthWiseInterestSummaryReportResponseChanged,
	getMonthWiseInterestSummaryReportSuccess,
} from './month-wise-interest-summary-report.action';
import {
	getMonthWiseInterestReport,
	monthWiseInterestSummaryReportExcelget,
} from './month-wise-interest-summary-report.service';
import MonthlyWiseInterestSummaryReportAction from './month-wise-interest-summary-report.type';

/*************** Get Month Wise Interest Summary Report Start ******************/
export function* monthWiseInterestSummaryReport({ payload }: any) {
	try {
		const key = 'GetMonthWiseInterestSummaryReportListKey';
		const { databaseName, companyID, branchID, asOnDate, LOANTYPE, limit } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchID: branchID,
			AsOnDate: asOnDate,
			LoanType: LOANTYPE,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getMonthWiseInterestReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMonthWiseInterestSummaryReportFailure(responseData.data));
		} else {
			yield put(getMonthWiseInterestSummaryReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMonthWiseInterestSummaryReportFailure(error));
	}
}

export function* resetGetMonthWiseInterestSummaryReportResponse() {
	yield put(getMonthWiseInterestSummaryReportResponseChanged());
}

export function* onGetMonthWiseInterestSummaryReport() {
	yield takeLatest(
		MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_START,
		monthWiseInterestSummaryReport,
	);
}

export function* onGetMonthWiseInterestSummaryReportResponseReset() {
	yield takeLatest(
		MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_RESPONSE_RESET,
		resetGetMonthWiseInterestSummaryReportResponse,
	);
}
/*************** Get Month Wise Interest Summary Report End ******************/

/*************** Get Month Wise Interest Summary Report Excel Start ******************/
export function* getMonthWiseSummaryReportExcel({ payload }: any) {
	try {
		const key = 'GetMonthWiseInterestSummaryReportExcelListKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			UserID: payload.userID,
			RequestID: payload.requestID,
			GeneralCompanyID: payload.generalCompanyID,
			CompanyID: payload.companyID,
			BranchID: payload.branchID,
			AsOnDate: payload.asOnDate,
			LoanType: payload.LOANTYPE,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(monthWiseInterestSummaryReportExcelget, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMonthWiseInterestSummaryReportExcelFailure(responseData.data));
		} else {
			yield put(getMonthWiseInterestSummaryReportExcelSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMonthWiseInterestSummaryReportExcelFailure(error));
	}
}

export function* resetMonthWiseInterestSummaryReportExcelResponse() {
	yield put(getMonthWiseInterestSummaryReportExcelResponseChanged());
}

export function* onMonthWiseInterestSummaryReportExcel() {
	yield takeLatest(
		MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_START,
		getMonthWiseSummaryReportExcel,
	);
}

export function* onMonthWiseInterestSummaryReportExcelResponseReset() {
	yield takeLatest(
		MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_RESPONSE_RESET,
		resetMonthWiseInterestSummaryReportExcelResponse,
	);
}
/*************** Get Month Wise Interest Summary Report Excel End ******************/

export function* monthWiseInterestSummaryReportSaga() {
	yield all([
		call(onGetMonthWiseInterestSummaryReport),
		call(onGetMonthWiseInterestSummaryReportResponseReset),
		call(onMonthWiseInterestSummaryReportExcel),
		call(onMonthWiseInterestSummaryReportExcelResponseReset),
	]);
}
